// Types
import type { SpGroupType } from '@/hooks/swr/group/useSPGroups';
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

export function getAnalyticsGroupUsedNetworkTypes(
    group: SpGroupType,
    aggregatedNetworks: SocialProfileNetworkType[]
) {
    return aggregatedNetworks?.filter(
        (network) =>
            group?.social_profiles?.findIndex((sp) => sp.social_network_type === network) > -1
    );
}
